import { useBackend } from "../../services";

export const useBackupDatabase = () => {
  const { post } = useBackend();
  return async () => post("admin/backupDatabase", {});
};
